<template>
  <div class="top_warp">
    <!--背景-->
    <div class="bg posr">
      <img class="bg_cont" src="@/assets/images/banner.png" alt="">
      <div class="dif alc logo_warp">
        <img :src="$store.state.url+logo">
        <div class="mrLft20 site_title">{{title}}</div>
      </div>
    </div>
    <!--一级菜单-->
    <div class="navbar w100 difb difw posr">
      <div class="tags difcac" @click="changeOne(item.id,item.name)"
           :class="{'active1':current===item.id}"
           v-for="(item,index) in cates" :key="index">{{item.name}}</div>
    </div>
    <!--二级菜单-->
    <div class="two mrTop20 dif difw">
      <el-row class="w100">
        <el-col class=""  v-for="(item,index) in twoCates" :key="index" :sm="4" :xs="8">
          <div class="tags2 difcac" @click="changeTwo(item.id)"
               :class="{'active':current2===item.id}"
              >{{item.title}}</div>
        </el-col>
      </el-row>
    </div>
    <!--咨询-->
    <div v-if="current2===-2" class="advice dif alc">
      <div v-for="(item,index) in advice" :key="index" class="advice_cont">
        <img class="advice_img" :src="$store.state.url+item">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "top",
  data() {
    return {
      logo: '',
      title: '',
      current: -1,//当前选择的一级分类
      cates: [ //一级分类
        {id: -1,name: '网站首页'},
      ],
      current2: -1,//当前选择的二次分类
      twoCates: [ //二级分类
        {id: -1,title: '网上报名'},
        {id: -2,title: '咨询'},
      ],
      advice: [],//咨询图片
    }
  },
  methods: {
    getAdvice() { //获取咨询
      this.$axios("POST",'/index/cms_system',{})
      .then(res=> {
        if(res.code===1) {
          this.advice = res.data.cx_images
        }
      })
    },
    changeOne(id,name) { //选择一级菜单
      this.current = id
      if(id===-1) { //首页
        this.$router.push('/')
      }else {
        this.$router.push({
          path: '/list',
          query: {
            id:id,
            name: name
          }
        }).catch(err => err)
      }
    },
    changeTwo(id) { //选择二级菜单
      if(this.current2===-2 && id===-2) {
        this.current2 = -3
        return
      }
      this.current2 = id
      if(id===-2) {
        return
      }
      if(id===-1) { //网上报名
        let routeUrl = this.$router.resolve({
          // path: '/signup'
          path: '/infoCenter/sign'
        })
        window.open(routeUrl .href, '_blank');
        return
      }
      this.$router.push('/list').catch(err => err)
    },
    //获取logo和标题
    getLogoTitle() {
      this.$axios("POST","/index/cms_system",{})
      .then(res => {
        if(res.code===1) {
          this.logo = res.data.image
          this.title = res.data.title
        }
      })
    },
    //获取顶部导航
    getTopNav() {
      this.$axios("POST",'/index/cms_channel',{})
      .then(res => {
        if(res.code===1) {
          this.cates = [...this.cates,...res.data]
        }
      })
    }
  },
  created() {
    this.getLogoTitle() //获取logo
    this.getTopNav()
    this.getAdvice()
  }
}
</script>

<style scoped>
  .bg_cont{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .top_warp{
    width: 80%;
    background: #FFFFFF;
    margin: 0 auto;
    position: relative;
    padding-top: 23.4rem;
  }

  .bg{
    position: absolute;
    width: 100%;
    height: 27.7rem;
    background: #00B7A4;
    top: 0;
    left: 0;
  }
  .logo_warp{
    position: absolute;
    top: 5rem;
    z-index: 22;
    left: 4rem;
  }
  .site_title{
    font-weight: bold;
    color: #FFFFFF;
    font-size: 4rem;
  }
  .logo_warp img{
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
    background: #FFFFFF;
  }
  .navbar{
    box-sizing: border-box;
    padding: 0 3rem;
    width: 100%;
    /*background: #07838d;*/
    background: rgba(7,131,141,0.7);
  }
  .tags{
    cursor: pointer;
    position: relative;
    width: 13.4rem;
    height: 4.5rem;
    /*background-color: #07838D;*/
    background: rgba(0,0,0,0);
    color: rgba(255, 255, 255, 1);
    font-size: 1.4rem;
    text-align: center;
    /*margin-bottom: 2rem;*/
  }
  .two{
    box-sizing: border-box;
    padding: 0 3rem;
    /*margin-top: 1.7rem;*/
    width: 100%;
  }
  .tags2{
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    width: 13.4rem;
    height: 4.5rem;
    background: #FFFFFF;
    color: #101010;
    box-sizing: border-box;
    border: 1px solid #07838D;
    font-size: 1.4rem;
    text-align: center;
    margin-bottom: 2rem;
    background: #daedee;
  }
  .active{
    background: #07838D;
    border: 1px solid #06676F;
    color: rgba(255, 255, 255, 1);
  }
  .active1{
    background: #06676f;
    border-radius: 6px;
  }
  .advice{
    width: 100%;
    z-index: 52;
    background: #FFFFFF;
    box-sizing: border-box;
    padding: 3.5rem 4.5rem;
    position: absolute;
    left: 0;
    overflow-x: auto;
    box-shadow: 0px 1.6rem 2rem 0px rgba(0, 0, 0, 0.2);
  }
  .advice_img{
    width: 27.7rem;
    height: 16.7rem;
    background: #cbcbcb;
  }
  .advice_cont:nth-last-child(1) {
    margin-right: 0;
  }
  .advice_cont{
    margin-right: 4.5rem;
  }
  @media (max-width: 560px) {
    .top_warp{
      width: 100%;
    }
  }
</style>